import {combineReducers} from 'redux';
import shoppingCart from './shopping_cart';
import pricing from './pricing';
import user from './user';
import prime from './prime';
import productSelection from './product_selection';
import ancillariesInformation from './ancillaries_information';
import dpPriceFees from './dpPriceFees';

const appReducer = combineReducers({
    shoppingCart,
    pricing,
    user,
    prime,
    productSelection,
    ancillariesInformation,
    dpPriceFees,
});

export const rootReducer = (state, action) => {
    if (action.type === 'SET_INITIAL_STORE') {
        state = action.entry;
    }
    return appReducer(state, action);
};
